/** Example output: 6:30 PM - 7:30 PM */
export const formatTimeRange = (
  appointmentStartTime?: string | null,
  appointmentEndTime?: string | null,
): string | JSX.Element => {
  if (!appointmentStartTime || !appointmentEndTime) {
    return '';
  }

  const formattedStartTime = new Date(appointmentStartTime).toLocaleTimeString([], {
    hour: 'numeric',
    minute: 'numeric',
  });

  const formattedEndTime = new Date(appointmentEndTime).toLocaleTimeString([], {
    hour: 'numeric',
    minute: 'numeric',
  });

  return (
    <>
      {formattedStartTime} <span className='sr-only'>to</span>
      <span aria-hidden>-</span> {formattedEndTime}
    </>
  );
};

/** example output: "Mon, Jun 24" */
export const formatShortAppointmentDate = (date: string) => {
  return new Date(date).toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
};

/** example output: "PDT" */
export const getBrowserTimezone = () => {
  return new Date().toLocaleTimeString(undefined, { timeZoneName: 'short' }).split(' ')[2];
};
